var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.8 60.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7,46.1H42.1V41.6A13.83,13.83,0,0,0,28.3,27.8H7.6V14.1H28.3A27.55,27.55,0,0,1,55.8,41.6v4.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8.7,
    width: 5.8,
    height: 24.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    width: 27,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3,
    y: 5.8,
    width: 5.2,
    height: 6.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7,48c.1.1.2.2.2.3,1.1,2.3,2.3,4.5,3.4,6.8a4,4,0,0,1-4.9,5.6,3.81,3.81,0,0,1-2.6-4.1,11.22,11.22,0,0,1,.8-2.6c.9-1.9,1.9-3.7,2.8-5.5A2.19,2.19,0,0,1,48.7,48Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWater);
export default __webpack_public_path__ + "static/media/icon-water.f886e1de.svg";
export { ForwardRef as ReactComponent };